<template>
<div class="files__wrapper">
  <el-dialog
    :show-close="false"
    :visible.sync="deleteVideoModal"
    width="750px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="deleteVideoModal = false">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Are you sure you want to delete this video(s)?</span>
        </div>
        <div class="modal-btn active" @click="handleDeleteConfirm('video', fileToDelete)">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div class="modal-videos" v-if="fileToDelete">
      <div class="modal-video">
        <div class="modal-video__title acr-bold-18"></div>
        <video :src="fileToDelete.original_video_url" :poster="fileToDelete.thumbnail_url" controls class="modal-video__src"></video>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    :show-close="false"
    :key="moveToModalKey"
    :visible.sync="moveToModal"
    width="460px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="closeMoveToModal">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Move to</span>
        </div>
        <div class="modal-btn" :class="{'active': moveToFolder}" @click="moveTo">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div>
      <div class="files__folder modal-folders" style="margin-bottom: 8px" v-if="currentFolder && currentFolder.folder_name !== 'root'">
        <svgicon name="Folder2" class="files__folder-icon"></svgicon>
        <div style="margin-top: 6px">
          <div class="files__folder-title acr-bold">Root</div>
          <div class="files__folder-info">Root folder</div>
        </div>
        <div class="files__video-progress-checkbox" style="top: 15px" v-if="!moveToFolder || moveToFolder.id === 2">
          <el-checkbox @change="selectMoveToFolder($event, {id: 2})"/>
        </div>
      </div>
      <div class="files__folder modal-folders" v-for="item in folders" :key="item.id + 1" style="margin-bottom: 8px">
        <svgicon name="Folder2" class="files__folder-icon"></svgicon>
        <div style="margin-top: 6px">
          <div class="files__folder-title acr-bold">{{item.folder_name}}</div>
          <div class="files__folder-info" v-if="item.videos_inside + item.folders_inside !== 0">
            {{item.videos_inside + item.folders_inside}} items
          </div>
          <div class="files__folder-info" v-else>Folder is empty</div>
        </div>
        <div class="files__video-progress-checkbox" style="top: 15px" v-if="!moveToFolder || moveToFolder.id === item.id">
          <el-checkbox @change="selectMoveToFolder($event, item)"/>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    :show-close="false"
    :visible.sync="deleteFolderModal"
    width="788px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="deleteFolderModal = false">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Are you sure you want to delete this folder(s)?</span>
        </div>
        <div class="modal-btn active" @click="handleDeleteConfirm('folder', fileToDelete)">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div class="modal-videos" v-if="fileToDelete">
      <div class="files__folder">
        <svgicon name="Folder2" class="files__folder-icon"></svgicon>
        <div style="margin-top: 6px">
          <div class="files__folder-title acr-bold">{{fileToDelete.folder_name}}</div>
          <div class="files__folder-info">{{fileToDelete.childs_ids ? fileToDelete.childs_ids.length + ' videos' : 'Folder is empty'}}</div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    :show-close="false"
    :visible.sync="newFolderModal"
    width="515px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="newFolderModal = false">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Create new folder</span>
        </div>
        <div class="modal-btn" :class="{'active': newFolderName}" @click="createNewFolder">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div class="modal-field">
      <div class="modal-field__label acr-bold-18">Folder name</div>
      <el-input label="Project name" v-model="newFolderName"></el-input>
    </div>
  </el-dialog>
  <el-dialog
    :show-close="false"
    :visible.sync="renameFolderModal"
    width="515px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="renameFolderModal = false">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Rename folder</span>
        </div>
        <div class="modal-btn" :class="{'active': newFolderName}" @click="editFolder">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div class="modal-field">
      <div class="modal-field__label acr-bold-18">Folder name</div>
      <el-input label="Project name" v-model="newFolderName"></el-input>
    </div>
  </el-dialog>
  <BaseLoader v-if="!currentFolder || loading" />
  <div class="files" :class="{'min': showFilter}" v-if="currentFolder && !loading">
    <div class="files__heading">
      <div class="files__upload">

          <div style="display:flex;align-items: center" v-if="currentFolder && currentFolder.parent_id">
            <div class="files__btn" @click="getFolder(currentFolder.parent_id)">
              <svgicon name="Chevron-left"></svgicon>
            </div>
            <span style="margin-left: 22px;text-transform: capitalize" class="acr-ultra-bold">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item
                  v-for="path in fullPath"
                  :key="path[0]"
                  @click="getFolder(path[Object.keys(path)[0]])">
                  <span @click="getFolder(path[Object.keys(path)[0]])">
                    {{Object.keys(path)[0]}}
                  </span>
                </el-breadcrumb-item>
              </el-breadcrumb>
            </span>
          </div>
          <el-upload
            v-if="currentFolder && !currentFolder.parent_id"
            accept="video/mp4,video/x-m4v,video/*,.mkv,.mov,.avi"
            class="upload-demo"
            ref="upload"
            action=""
            multiple
            :before-upload="handleBeforeUpload"
            :http-request="uploadRequest"
            :on-progress="handleUploadProgress"
            :on-success="handleUploadSuccess"
            :on-change="handleChangeUpload"
            :show-file-list="false">
            <div slot="trigger" style="display:flex;align-items: center">
              <div class="files__btn files__btn--green">
                <svgicon name="Plus"></svgicon>
              </div>
              <span class="acr-ultra-bold" style="margin-top: -2px">Add video</span>
            </div>
          </el-upload>
      </div>
      <div style="display: flex;align-items: center">
        <el-upload
          v-if="currentFolder && currentFolder.folder_name !== 'root'"
          accept="video/mp4,video/x-m4v,video/*,.mkv,.mov,.avi"
          class="upload-demo"
          ref="upload"
          action=""
          multiple
          :before-upload="handleBeforeUpload"
          :http-request="uploadRequest"
          :on-progress="handleUploadProgress"
          :on-success="handleUploadSuccess"
          :on-change="handleChangeUpload"
          :show-file-list="false">
          <div slot="trigger" style="display:flex;align-items: center">
            <div class="files__btn files__btn--default">
              <span style="margin-top: -3px">Add video</span>
            </div>
          </div>
        </el-upload>

        <div class="files__btn files__btn--default" @click="newFolderModal = true">
          <span style="margin-top: -3px">Create folder</span>
        </div>
        <div class="files__btn" @click="showFilter = !showFilter">
          <svgicon name="Filter" style="width: 19px;height: 19px;"></svgicon>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="files__folders">
        <div class="files__folder" v-for="item in searchActive ? searchResults.folders_data.folders : folders" :key="item.id" @click.exact="getFolder(item.id)">
          <svgicon name="Folder2" class="files__folder-icon"></svgicon>
          <div style="margin-top: 6px">
            <div class="files__folder-title acr-bold">{{item.folder_name}}</div>
            <div class="files__folder-info" v-if="item.videos_inside + item.folders_inside !== 0">
              {{item.videos_inside + item.folders_inside}} items
            </div>
            <div class="files__folder-info" v-else>Folder is empty</div>

          </div>
          <div class="files__folder-options">
            <el-dropdown @command="openDeleteFolderModal($event, item)">
              <span><svgicon name="More2"></svgicon></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="item.videos_inside + item.folders_inside !== 0" command="delete">Delete</el-dropdown-item>
                <el-dropdown-item command="rename">Rename</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="files__videos" :key="rerender">
        <div class="files__video" v-for="item in searchActive ? searchResults.videos_data.videos : videos"
             :key="item.id">
          <div class="files__video-progress" v-if="item.progress !== 100">
            <div class="files__video-progress-bar" :style="`width: ${item.progress}%`" v-if="!item.error_during_processing"></div>
            <div class="files__video-progress-error" @click="reprocess(item)" v-if="item.error_during_processing">
              <svgicon name="ArrowCounterClockwise"></svgicon>
              <span class="acr-regular" style="margin-left: 9px">Restart processing</span>
            </div>
            <div class="files__video-options">
              <el-dropdown trigger="hover" @command="handleDeleteConfirm('video', item)">
                <svgicon name="More2"></svgicon>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item >Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="files__video-progress-info">
              <div class="files__video-progress-name acr-bold">{{item.display_name ? truncateString(item.display_name, 20) : truncateString(item.video_name, 20)}}</div>
              <div class="files__video-progress-status">
                <span v-if="item.progress === 0" class="acr-regular">In queue</span>
                <span v-if="item.progress > 0" class="acr-regular">
                  <span>Processing</span>
                  <span v-if="item.error_during_processing">&nbsp;(Error)</span>
                </span>
              </div>
            </div>
            <div class="files__video-progress-checkbox">
              <el-checkbox @change="handleSelect($event, item)" :ref="item.id"/>
            </div>
          </div>
          <div class="files__video-clickable" @click="$router.push({ name: 'video', params: { videoId: item.id }})" v-if="item.progress === 100"></div>
          <div class="files__video-overlay" v-if="item.progress === 100">
            <svgicon name="Play" class="video-play"></svgicon>
            <div class="files__video-options">
              <el-dropdown @command="openDeleteVideoModal($event, item)">
                <span>
                  <svgicon name="More2"></svgicon>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete</el-dropdown-item>
                  <el-dropdown-item command="moveto">Move to</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="files__video-info">
              <div class="files__video-name">
                <span class="acr-bold">{{item.display_name ? truncateString(item.display_name, 20) : truncateString(item.video_name, 20)}}</span>
              </div>
              <div class="files__video-date acr-regular">{{new Date(item.created_at).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}}</div>
            </div>
            <div class="files__video-checkbox">
              <el-checkbox @change="handleSelect($event, item)" :ref="item.id"/>
            </div>
          </div>
          <img :src="item.thumbnail_url"
               alt=""
               v-if="item.thumbnail_url && item.video_size && item.progress === 100"
               class="files__video-preview">
        </div>
      </div>
      <SmallFooter :hide="currentFolder.folder_name !== 'root'"></SmallFooter>
    </div>
  </div>
  <BaseFilter
    :show-filter="showFilter"
    :show-sorting="true"
    :one-column="true"
    @close="showFilter = false"
    @sort="sorting = $event"
    :key="rerenderFilters">
    <div v-for="item in filters" :key="item.item_label">
      <div class="filter__subtitle acr-medium-18">{{item.item_label}}</div>
      <div style="display: flex;flex-direction: column">
          <el-checkbox v-for="v in item.filter_values" :key="v" @change="onFilterSelect($event, item.filter_var, v)">
            <span class="acr-medium">{{v}}</span>
          </el-checkbox>
      </div>
    </div>
    <div class="filter-btn acr-bold" slot="clear" v-if="filtersApplied" @click="clearFilters">Clean</div>
  </BaseFilter>

</div>
</template>

<script>
  import { getFolderById, createFolder, getRootFolder, deleteFolder, updateFolder, searchFolder, getFiltersForFolder } from "../../api/folders";
  import { fetchSuggestionInFiles, uploadVideo, getGcpSignedURL, updateVideo, processVideo } from "../../api/files";
  import { mapActions, mapGetters } from 'vuex';
  import BaseFilter from '../../components/BaseFilter';
  import BaseLoader from '../../components/BaseLoader';
  import SmallFooter from '../../components/footer/SmallFooter';

  export default {
    name: "Files",
    components: { BaseFilter, SmallFooter, BaseLoader },
    data() {
      return {
        search: '',
        rerender: 0,
        searchActive: false,
        searchResults: [],
        addNewFileModal: false,
        deleteItemModal: false,
        deleteVideoModal: false,
        moveToModal: false,
        moveToModalKey: 1000,
        moveToVideo: null,
        deleteFolderModal: false,
        renameFolderModal: false,
        folderToRename: null,
        fileToDelete: null,
        newFolderModal: false,
        moveToFolder: '',
        isEdit: false,
        newFolderName: '',
        currentFolder: null,
        selectedPreview: null,
        videos: null,
        folders: null,
        creatingNewFolder: false,
        loading: false,
        openRootFolderByDefault: true,
        showFilter: false,
        filters: [],
        selectedFilters: [],
        rerenderFilters: 0,
        sorting: 'desc'
      }
    },
    watch: {
      search(v) {
        this.loading = true;
        if (this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          if (v && v.trim().length > 0) {
            searchFolder(v).then((res) => {
              this.searchResults = res.data;
              this.loading = false;

            });
            this.searchActive = true;
          } else {
            this.searchActive = false;
            this.loading = false;
          }

        }, 300);
      },
      selectedVideos(v) {
        if (!v.length) {
          this.rerender += 1;
        }
      },
      selectedFilters() {
        const query = {};
        this.transformedFilters.forEach((item) => {
          query[Object.keys(item)[0].toLowerCase()] = item[Object.keys(item)[0]];
        });

        this.refreshItems(query);
      },
      sorting() {
        const query = {};
        this.transformedFilters.forEach((item) => {
          query[Object.keys(item)[0].toLowerCase()] = item[Object.keys(item)[0]];
        });

        this.refreshItems(query);
      },
      currentFolder(v) {
        if (v.id) {
          getFiltersForFolder(v.id).then((res) => {
            this.filters = res.data.left_filters.filter((item) => item.filter_values.length > 0).reverse();
          })
        }
      },
    },
    computed: {
      ...mapGetters({
        uploadFiles: 'uploadFiles',
        selectedVideos: 'selectedVideos',
      }),
      transformedFilters() {
        const arrayOfFilters = Object.keys(this.selectedFilters).map((item) => {
          return {[item]: Object.keys(this.selectedFilters[item]).filter((x) => !!this.selectedFilters[item][x]).join()};
        });

        return arrayOfFilters
      },
      filtersApplied() {
        return this.transformedFilters.filter((i) => !!i[Object.keys(i)[0]]).length
      },
      fullPath() {
        const copyPath = this.currentFolder.full_path;
        copyPath.reverse().shift();

        return copyPath
      },
    },
    beforeRouteEnter(to, from, next) {
      if (to.params.folderId || to.params.id) {
        next((vm) => {
          vm.getFolder(to.params.folderId || to.params.id);
          vm.openRootFolderByDefault = false;
        })
      } else {
        next((vm) => {
          vm.openRootFolderByDefault = true
        })
      }
    },
    mounted() {
      if (this.openRootFolderByDefault) {
        this.getRootFolder();
      }

      this.$socket.on('video-status-update', (e, data) => {
        if (data.status === 100) {
          this.refreshItems();
        }
        this.videos = this.videos.map((i) => {
          if (i.id === data.id) {
            return {...i, progress: data.status}
          } return i
        })
      })

      this.$eventBus.$on('refreshFiles', this.refreshItems);
    },
    methods: {
      ...mapActions({
        deleteVideo: 'deleteVideo'
      }),
      selectMoveToFolder(v, folder) {
        this.moveToFolder = v ? folder : null
      },
      closeMoveToModal() {
        this.moveToModal = false;
        this.moveToFolder = null;
        this.moveToVideo = null;
        this.moveToModalKey += 1;
      },
      editFolder() {
        this.creatingNewFolder = true;
        let formD = new FormData();

        formD.append('name', this.newFolderName);

        updateFolder(formD, this.folderToRename.id).then(() => {
          this.renameFolderModal = false;
          this.newFolderName = '';
          this.refreshItems();
        });
      },
      moveTo() {
        if (!this.moveToFolder) return

        const formData = new FormData();
        formData.append('parent_id', this.moveToFolder.id);

        updateVideo(formData, this.moveToVideo.id).then(() => {
          this.closeMoveToModal();
          this.refreshItems();
        });
      },
      clearFilters() {
        this.selectedFilters = [];
        this.rerenderFilters += 1;
      },
      onFilterSelect(value, filter, field) {
        const v = typeof value === 'object' ? value.target.checked : value;
        this.selectedFilters = {
          ...this.selectedFilters,
          [filter]: {
            ...this.selectedFilters[filter],
            [field]: v
          },
        };
      },
      reprocess(item) {
        item.progress = 0;
        item.error_during_processing = false;
        processVideo(item.id).then(() => this.$forceUpdate());
      },
      truncateString(str, num) {
        if (str.length > num) {
          return str.slice(0, num) + "...";
        } else {
          return str;
        }
      },
      uploadRequest(option) {
        const formData = new FormData();
        let videoId;

        if (option.data) {
          Object.keys(option.data).forEach((key) => {
            formData.append(key, option.data[key]);
          });
        }

        formData.append(option.filename, option.file);

        getGcpSignedURL(window.location.origin, option.file.name, this.currentFolder.id).then(data => {
          videoId = data.data.video_id;

          const config = {
            onUploadProgress(e) {
              e.percent = Math.round((e.loaded * 100) / e.total);
              option.onProgress({...e, videoId});
            }
          };

          uploadVideo(option.file, data.data.url, config).then(() => {

            const statusFormData = new FormData();
            statusFormData.append('status', 'uploaded');
            statusFormData.append('parent_id', this.currentFolder.id);

            updateVideo(statusFormData, videoId).then((res) => {
              option.onSuccess({ ...option.file, status: 'uploaded', videoId: res.data.msg.replace(/[^0-9]/g,'')});
              this.$emit('success');
            });
          }).catch((e) => this.handleError(e, option.file));
        });

      },
      handleUploadSuccess(file) {
        this.$store.dispatch('updateUpload', file);
      },
      handleUploadProgress(event, file) {
        const id = event.videoId;
        this.$store.dispatch('updateUpload', {...file, videoId: id});
      },
      handleChangeUpload(file) {
        if (file.status === 'ready') {
          const fileUrl = URL.createObjectURL(file.raw);
          this.$store.dispatch('addUpload', {...file, preview: fileUrl});
        }
      },
      handleBeforeUpload(file) {
        // Check upload size compliant
        // if (file.size > 53687091200) {
        //   this.doAlert('warningmessage.upload_filesize_exceed', { filename: file.name, limit: '10 GB' });
        //   return false;
        // }
        // Check upload duplication compliant
        if (this.uploadFiles.some(
          item => item.uid !== file.uid && item.name === file.name && item.size === file.size,
        )) {
          this.$store.dispatch('removeUpload', file.uid);
          return false;
        }

        return true;
      },
      handleDeleteUpload(file) {
        const videoToDelete = file.videoId || file.response.videoId;
        this.deleteVideo(videoToDelete);
      },
      handleSelect(value, video) {
        if (value) {
          this.$store.dispatch('addSelectedVideo', video);
        } else {
          this.$store.dispatch('removeSelectedVideo', video);
        }
      },
      fetchAutocomplete(str, cb) {
        fetchSuggestionInFiles(str).then((res) => {
          cb(res.data.suggestions)
        });
      },
      handleSelectSuggestion(item) {
        this.search = item;
      },
      bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      },
      secondsToHms(d) {
        d = Number(d);

        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        return ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
      },
      openDeleteVideoModal(command, file) {
        if (command === 'moveto') {
          this.moveToModal = true;
          this.moveToVideo = file;
        } else {
          this.deleteVideoModal = true;
          this.fileToDelete = file;
        }
      },
      openDeleteFolderModal(command, file) {
        if (command === 'delete') {
          this.deleteFolderModal = true;
          this.fileToDelete = file;
        } else {
          this.renameFolderModal = true;
          this.folderToRename = file;
          this.newFolderName = file.folder_name;
        }
      },
      handleDeleteConfirm(type = 'video', itemToDelete) {
        if (type === 'video') {
          this.deleteVideo(itemToDelete.id);
          this.videos = this.videos.filter((item) => item.id !== itemToDelete.id);
          this.deleteVideoModal = false;
        } else {
          this.deleteFolder(itemToDelete);
          this.deleteFolderModal = false;
        }
        this.fileToDelete = null;
      },
      createNewFolder() {
        let formD = new FormData();

        formD.append('name', this.newFolderName);
        formD.append('parent_id', this.currentFolder.id);

        createFolder(formD).then(() => {
          this.newFolderModal = false;
          this.newFolderName = '';

          this.refreshItems();
        });
      },
      refreshItems(q = {}) {
        if (this.currentFolder.folder_name === 'root') {
          this.getRootFolder(q)
        } else {
          this.getFolder(this.currentFolder.id, q);
        }
      },
      openEditModal() {
        this.newFolderModal = true;
        this.isEdit = true;
        this.newFolderName = this.currentFolder.folder_name
      },
      getFolder(id, q = {}) {
        this.loading = true;
        this.currentFolder = getFolderById(id, q, this.sorting).then(res => {
          this.currentFolder = res.data;
          if (res.data.folder_name !== 'root') {
            this.videos = this.currentFolder.videos_data.videos;
            this.folders = this.currentFolder.folders_data.folders;
            this.$store.commit('setCurrentFolderId', this.currentFolder.id);
            this.loading = false;
            this.initialPreview();
          } else {
            this.getRootFolder();
          }

        });

        if (this.$route.params.id !== id) this.$router.push({ params: { id }});
        this.search = ''
      },
      getRootFolder(q = {}) {
        getRootFolder(q, this.sorting).then(res => {
          this.currentFolder = res.data;
          this.videos = this.currentFolder.videos_data.videos;
          this.folders = this.currentFolder.folders_data.folders;
          this.$store.commit('setCurrentFolderId', this.currentFolder.id);
          if(this.videos && this.videos.length > 0) {
            this.selectedPreview = this.videos[0]
          }
          this.loading = false;
        });
      },
      deleteFolder(folder) {
        deleteFolder(folder.id).then(() => {
          this.getFolder(folder.parent_id);
        })
      },
      initialPreview() {
        if(this.currentFolder.folder_name === 'root' && this.videos && this.videos.length > 0) {
          this.selectedPreview = this.videos[0];
        } else {
          this.selectedPreview = this.currentFolder;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/
  .modal-folders {
    .el-checkbox {
      margin: 0 !important;
      &.is-checked {
        .el-checkbox__inner {
          width: 27px;
          height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 1;
          &::after {
            width: 14px;
            height: 11px;
            content: url("../../assets/svg/Done.svg");
            transform: scale(1) translate(-50%, -60%);
            border: none;
            left: 50%;
            top: 50%;
          }
        }
      }
      &__inner {
        width: 27px;
        height: 26px;
        border: none;
        background: rgba(36, 49, 67, 0.1);
        opacity: 0.7;
        &::after {
          width: 14px;
          height: 11px;
          content: url("../../assets/svg/Done.svg");
          transform: scale(0);
          transition: all .3s ease;
          border: none;
        }
      }
    }
  }
  /deep/
  .files {
    .el-checkbox {
      &.is-checked {
        .el-checkbox__inner {
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 1;
          &::after {
            width: 14px;
            height: 11px;
            content: url("../../assets/svg/Done.svg");
            transform: scale(1) translate(-50%, -60%);
            border: none;
            left: 50%;
            top: 50%;
          }
        }
      }
      &__inner {
        width: 30px;
        height: 30px;
        border: none;
        background: #FFFFFF;
        opacity: 0.7;
        &::after {
          width: 14px;
          height: 11px;
          content: url("../../assets/svg/Done.svg");
          transform: scale(0);
          transition: all .3s ease;
          border: none;
        }
      }
    }
  }

  /deep/

  .el-breadcrumb {
    &__inner {
      font-size: 18px !important;
      color:#00204D !important;
      &:hover {
        transition: all .3s ease-in-out;
        color: #8AAF1A !important;
      }
    }

    &:last-child {

      &__inner {
        opacity: .5;
        font-size: 18px !important;
        color:#00204D !important;
        font-weight: 400 !important;
        font-family: 'AcronisCyberMedium';
      }
    }
  }

</style>
